
import {Redirect} from '@shopify/app-bridge/actions';

export default class KotobeeApi {

    constructor(options = {}) {
        this.authFetch = options.authFetch;
        this.domain = window.$appDomain;
        this.accessToken = options.sessionToken;//"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"//options.accessToken;
        this.apiVersion = 2;
        this.store = options.store;

    }
    getKotobeeResources(callback) {
        let url = this.domain + '/plugins/shopify/ajax';
        let data = {
            action : "getResources"
        };
        this.processRequest(url, data, callback);
    }
    getProductAccessList(count, cursor, callback) {
        let url = this.domain + "/plugins/shopify/ajax";
        let data = {
            count,
            "action" : "getProductAccessList"
        };
        if (cursor) data['cursor'] = cursor;
        
        this.processRequest(url, data, callback);
    }
    getProduct(product_id, callback) {
        let url = this.domain + "/plugins/shopify/ajax";
        let data = {
            product_id,
            action: "getProduct"
        };
        this.processRequest(url, data, callback);
    }
    /**
     * Gets access object for a single product
     * @param {String} id product Graphql ID
     * @param {Function} callback The callback function
     */
    getSingleProductAccess(id, callback) {
        console.log("getSingleProductAccess",id);
        let url = this.domain + "/plugins/shopify/ajax";
        let data = {
            id,
            action: "getSingleProductAccess"
        };
        this.processRequest(url, data, callback);
    }
    updateProductAccess(product_id, access, callback) {
        let url = this.domain + "/plugins/shopify/ajax";
        let data = {
            product_id,
            access,
            action: "updateProductAccess"
        };
        this.processRequest(url, data, callback);
    }
    getShopifySettings(callback) {
        let url = this.domain + "/plugins/shopify/ajax";
        let data = {
            action: "getSettings"
        };
        this.processRequest(url, data, callback);
    }

    postShopifySettings(data, callback) {
        let url = this.domain + "/plugins/shopify/ajax";
        data['action'] = 'updateSettings';
        this.processRequest(url, data, callback);
    }

    createCharge(data, callback) {
        let url = this.domain + "/plugins/shopify/ajax";
        data['action'] = 'createCharge';
        this.processRequest(url, data, callback);
    }

    // Example POST method implementation:
    async postData(url = '', data = {}) {
        data['v'] = this.apiVersion;

        // Default options are marked with *
        let options = {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'same-origin', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Access-Token': this.accessToken
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data) // body data type must match "Content-Type" header
        };

        const response = await this.myFetch(url, options);

        return response.json(); // parses JSON response into native JavaScript objects
 
    }

    // Example GET method implementation:
    async getData(url = '') {
        // Default options are marked with *
        const response = await this.myFetch(url);

        return response.json(); // parses JSON response into native JavaScript objects
    }
    myFetch(url, options = {}) {
        if (this.authFetch) 
            return this.authFetch(url, options);

        return fetch(url, options);
    }
    /**
     * Filters response and makes additional logic before returning back to the callback function
     * @param {String} url 
     * @param {*} data 
     * @param {Function} callback 
     * @param {String} method 
     */
    processRequest(url, data, callback, method = 'post') {
        // this.progress.start(data.action);
        let store = this.store; 
        store.commit('setBusy', true);

        let fetched = null;
        if (method == 'post')
            fetched = this.postData(url, data);
        else
            fetched = this.getData(url);

        fetched.then(function(response) {
            // this.progress.stop(data.action);
            store.commit('setBusy', false);

            if (!response) {
                alert("Empty response");
                return;
            }
            if (response.error) 
                return alert("Unexpected error! " + response.error);
            if (callback)
                callback(response);
        }).catch(err => {
            if (callback)
                callback(err);
        });
    }
    
}